import { ca } from '@cian/analytics';

export function trackShowOnboarding() {
  ca('eventSite', {
    action: 'show_sopr',
    category: 'NewbuildingReviews',
    label: 'onboarding',
    name: 'oldevent',
    useLastProducts: true,
  });
}
